import {URL_API_CALIBRATION_QA_SEARCH, URL_API_WORKLISTING_AGENT_SUBMIT, URL_API_CALIBRATION_DATA_SEARCH, URL_API_CALIBRATION_DATA_ASSIGN, URL_API_WORKLISTING_ITEM_AUDITOR,
  URL_API_WORKLISTING_ITEM_AUDITOR_COMPLETED, URL_API_WORKLISTING_ITEM_AGENT_COMPLETED,URL_API_WORKLISTING_ITEM_SUBMIT, URL_API_WORKLISTING_ITEM_SCORES,
  URL_API_WORKLISTING_ITEM_AGENT, URL_API_WORKLISTING_ITEM_COUNT, URL_API_REASSIGN_DATA_SEARCH, URL_API_REASSIGN_DATA_ASSIGN,URL_API_WORKLISTING_ITEM_AGENT_LIST,
  URL_API_WORKLISTING_ITEM_SEARCH, URL_CALIBRATION_STATUS} from '../apiHitFile'
import _ from 'lodash';

 //Calibration 
export function SearchQANames(data){
  return (dispatch, getState) => {    
    dispatch(SearchQANamesPending())
    const currentToken = getState().LoginReducer.session;  
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    headers.append("Authorization", currentToken);
    fetch(URL_API_CALIBRATION_QA_SEARCH, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((res) => res.json())
      .then(json =>{dispatch(SearchQANamesSucesss(json)) })
      .catch(error =>{ dispatch(WorkItemError(error)) })
  }
}
export function SearchQANamesPending(){ 
  return {
    type: "SEARCH_CALIBARATION_QA_PENDING",
    isPending:true
  }
}
export function SearchQANamesSucesss(data){ 
  if(data.status === 1001 && !_.isEmpty(data.value)){
  return {
      type: "SEARCH_CALIBARATION_QA_NAMES",
      QANameList:data.value,
      isPending:false
    }
  } else {
    return {
      type:"WORKITEM_ERROR",
      showerror: true,
      errmessage: data.message
    }
  }
}

export function SearchCalibarationAction(data){
  return (dispatch, getState) => {  
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch(SearchCalibarationActionPending())
    fetch(URL_API_CALIBRATION_DATA_SEARCH, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((res) => res.json())
      .then(json => dispatch({type: "SEARCH_CALIBARATION_SUCCESS", searchData:json.value, isPending:false}))      
      .catch(error => dispatch(WorkItemError(error)))
  }
}

export function ResetCalibration(){
  return {
      type: "SEARCH_CALIBARATION_SUCCESS",
      searchData:[],
      isPending:false
  }
}

export function SearchCalibarationActionPending(){
  return {
      type: "SEARCH_CALIBARATION_PENDING",
      isPending:true
  }
}

export function AssignCalibrationAction(data, obj){
  return (dispatch, getState) => { 
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_CALIBRATION_DATA_ASSIGN, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((res) => res.json())
      .then(json => {
        dispatch(WorkItemError(json))
        dispatch(SearchCalibarationAction(obj))
      })
      .catch(error => dispatch(WorkItemError(error)))
  }

}

export function getCaLibrtionStatus(data){
  return (dispatch, getState) => { 
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_CALIBRATION_STATUS, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((res) => res.json())
      .then(json => {
        dispatch(getCaLibrtionStatusSuccess(json))
      })
      .catch(error => {
        dispatch(WorkItemError(error))
        dispatch(ResstgetCaLibrtionStatusSuccess(error))

      })
  }
}
export function getCaLibrtionStatusSuccess(data){ 
  if(data.status === 1001){
  return {
      type: "CALIBRATION_STATUS",
      calibrationStatus:data,
      isPending:false
    }
  } else {
    return (WorkItemError(data),
    ResstgetCaLibrtionStatusSuccess())
  }
}
export function ResstgetCaLibrtionStatusSuccess(data){ 
  return {
      type: "CALIBRATION_STATUS",
      calibrationStatus:[],
      isPending:false
  }  
}



export function ShowMessagePopUpFunction(err){
  return {
    type: "SHOW_POP_UP_MESSAGE",
    showPopUp:true,
    showPopUpmessage:err.message
  }
}
export function ShowMessagePopUpFunctionFalse(){
  return {
    type: "SHOW_POP_UP_MESSAGE_FALSE",
    showPopUp:false
  }
}
export function showAgentQARelated(){
  return (dispatch, getState) => {
    let userName = getState().LoginReducer.loginAction.userName;
    let obj = {userId:userName}
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WORKLISTING_ITEM_AGENT_LIST, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then(json => {
        dispatch({        
        type: 'AGENTS_LIST_SUCCESS', agentData:json.value}
        )
      })
      .catch(error => dispatch(WorkItemError(error)))
  }  
}
export function WorkItemListingActionAgent(obj){  
  return (dispatch, getState) => {
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    headers.append('Timezone',Intl.DateTimeFormat().resolvedOptions().timeZone);
    fetch(URL_API_WORKLISTING_ITEM_AGENT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then(json => dispatch({type: 'WORKITEM_LISTING_ACTION_AGENT', agentbox:json.value}))
      .catch(error => dispatch(WorkItemError(error)))
  }  
}
export function WorkItemListingActionAuditor(obj){ 
  return (dispatch, getState) => {
    dispatch(WorkItemPending())
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    headers.append('Timezone',Intl.DateTimeFormat().resolvedOptions().timeZone);
    fetch(URL_API_WORKLISTING_ITEM_AUDITOR, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json()) 
     .then(json => dispatch({type: 'WORKITEM_LISTING_ACTION_AUDITOR', auditorbox:json.value, isPending:false}))
     .catch(error => dispatch(WorkItemError(error)))
  }  
}
export function EvaluatedTemplateAction(object, id, voiceFeedback, now, then){  
  return (dispatch, getState) => {      
    dispatch(enanbleSpinner(true))
    let userName = getState().LoginReducer.loginAction.userName;
    let obj ={'id':id, 'templateValue':object, "VoiceFeedback":voiceFeedback ? voiceFeedback : '', 
      userName, 'startDateTime':now,  'endDateTime':then} 
    let headers = new Headers()
    fetch(URL_API_WORKLISTING_ITEM_SUBMIT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json()) 
    .then(json => {
      dispatch(EvaluatedTemplateActionSubmitSuccess(json))
      dispatch(WorkItemError(json))
    })
    .catch(error => {dispatch(WorkItemError(error))
      dispatch(enanbleSpinner(false)) 
    })
  }
}
export function enanbleSpinner(data){
  return{
    type: 'ENABLE_SPINNER',
    isSpinner: data
  }
}
export function EvaluatedTemplateActionSubmitSuccess(data){
  if(data.status === 1001){
  return{
    type: 'SUBMIT_AUDITOR',
    submitted: true,
    isSpinner:false
  }
 } else {
    return {
      type:"WORKITEM_ERROR",
      showerror: true,
      errmessage: data.message
    }
  }   
}
export function EvaluatedTemplateActionagent(object, id){  
  return (dispatch, getState) => {  
    let userName = getState().LoginReducer.loginAction.userName;
    let obj ={'id':id, 'templateValue':object.templateValue, userName, 'agentSubmit':true} 
    
    let headers = new Headers()
    fetch(URL_API_WORKLISTING_AGENT_SUBMIT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json()) 
    .then(json => {
    // dispatch(EvaluatedTemplateActionagentSuccess(json))
      dispatch(WorkItemError(json))
    })
    .catch(error => dispatch(WorkItemError(error)))
  }
}
// export function EvaluatedTemplateActionagentSuccess(data){
//   if(data.status === 1001){
//   return{
//     type: 'SUBMIT_AUDITOR',
//     submitted: true
//   }
//  } else {
//     return {
//       type:"WORKITEM_ERROR",
//       showerror: true,
//       errmessage: data.message
//     }
//   }   
// }
export function ScoreCalculation(id){
  return (dispatch, getState) => {  
    let userName = getState().LoginReducer.loginAction.userName;
    let headers = new Headers()    
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WORKLISTING_ITEM_SCORES, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(id,userName)
    }).then((res) => res.json())     
    .then(json => dispatch(ScoreCalculationSuccess(json)))    
    .catch(error => dispatch(WorkItemError(error)))
  }
}
export function ScoreCalculationSuccess(data){
  if(!_.isEmpty(data) && data.status === 1001){
    return{
        type:"WORKITEM_COMPLETED_SCORES",
        ScoreCalculation:data.value
    }
  } else {
    return{
      type:"WORKITEM_ERROR",
      showerror: true,
      errmessage: data.message,
      isPending:false
    }
  }
}

export function ResetSubmitted(){
  return{
    type: 'SUBMIT_AUDITOR_RESET',
    submitted: false,
  } 
}
export function WorkItemPending(){
  return{
    type:"WORK_ITEM_PENDING",
    isPending:true
  }
}
export function WorkItemListingActionAuditorCompleted(obj){
  return (dispatch, getState) => {
    dispatch(WorkItemPending())
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    headers.append('Timezone',Intl.DateTimeFormat().resolvedOptions().timeZone);
    fetch(URL_API_WORKLISTING_ITEM_AUDITOR_COMPLETED, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then(json => dispatch({type: 'WORKITEM_LISTING_ACTION_AUDITOR_COMPLETED', completedauditor:json.value, isPending:false}))    
      .catch(error => dispatch(WorkItemError(error)))
  }  
}
export function WorkItemListingActionAgentCompleted(obj){ 
  return (dispatch, getState) => {
    dispatch(WorkItemPending())
    let headers = new Headers()    
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    headers.append('Timezone',Intl.DateTimeFormat().resolvedOptions().timeZone);
    fetch(URL_API_WORKLISTING_ITEM_AGENT_COMPLETED, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
     .then(json => dispatch({type: 'WORKITEM_LISTING_ACTION_AGENT_COMPLETED', completedagent:json.value, isPending:false}))    
     .catch(error => dispatch(WorkItemError(error)))
  }  
}
export function WorkItemListingActionCount(obj){ 
  return (dispatch, getState) => {
    let userName = getState().LoginReducer.loginAction.userName;
    let object = {...obj, userName}
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
   // headers.append('Authorization',currentTokenType+" "+currentToken);
    fetch(URL_API_WORKLISTING_ITEM_COUNT, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(object)
    }).then((res) => res.json())
    .then(json => dispatch({type: 'WORKITEM_LISTING_ACTION_COUNT', count:json.value}))
    .catch(error => console.log(error))
  }  
}
export function searchReAssignRecords(data){  
  return (dispatch, getState) => {  
    dispatch({type: 'REASSIGNED', reassiged:false})
    let userName = getState().LoginReducer.loginAction.userName;
    let obj = {...data, userName}
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    dispatch({type: "SEARCH_REASSIGN_PENDING", isPending:true})
    fetch(URL_API_REASSIGN_DATA_SEARCH, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json())
      .then(json => dispatch(searchReAssignRecordsSuccess(json)))  
      .catch(error => dispatch(WorkItemError(error)))
  }
}
export function searchReAssignRecordsSuccess(data){
  if(data.status === 1001 && !_.isEmpty(data.value)){
  return {
    type: "SEARCH_REASSIGN_SUCCESS", 
    searchReAssignData:data.value, 
    isPending:false
  }
 } else {
  return {
    type:"WORKITEM_ERROR",
    showerror: true,
    errmessage: data.message
  }
 }
}
export function submitReAssignRecords(data){
  return (dispatch, getState) => {  
    dispatch({type: 'REASSIGNED', reassiged:false})
    //const currentTokenType = getState().LoginReducer.currentTokenType;
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_REASSIGN_DATA_ASSIGN, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(data)
    }).then((res) => res.json()) 
      .then(json => {dispatch(SuccessSubmit(json))
        dispatch({type: 'REASSIGNED', reassiged:true})
      }) 
      .catch(error => dispatch(WorkItemError(error)))
  }
}
export function SuccessSubmit(data){
  if(data.status === 1001){
    return {
    type: "WORKITEM_ERROR", 
    showerror: true, 
    errmessage: data.message,     
  }
  } else {
    return {
      type:"WORKITEM_ERROR",
      showerror: true,
      errmessage: data.message
    }
  }
}
export function SearchWorkItemRecords(data){
  return (dispatch, getState) => {  
    let userName = getState().LoginReducer.loginAction.userName;
    let obj={...data, userName}
    let headers = new Headers()
    headers.append('Content-Type','application/json');
    headers.append('Accept','application/json');
    fetch(URL_API_WORKLISTING_ITEM_SEARCH, {
      method: 'POST',
      headers : headers,
      body:JSON.stringify(obj)
    }).then((res) => res.json()) 
     .then(json => dispatch(SearchWorkItemRecordsSuccess(json))) 
     .catch(error => dispatch(WorkItemError(error)))
  }
}

export function SearchWorkItemRecordsSuccess(data){
  if(!_.isEmpty(data.value)){
  return{
    type:"SEARCH_RECORD_SUCCESS",
    searchRecord:data.value
  }
  }
}
export function ResetAll(){
  return{
    type:"RESET_ALL",
    reassiged:false
  }
}
export function WorkItemError(data){
  return{
    type:"WORKITEM_ERROR",
    showerror: true,
    errmessage: data.message,
    isPending:false

  }
}
export function closeModalPopUp(){
  return{
    type:'WORKITEM_MODAL_CLOSE',
    showerror:false
  }
}




